import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useFormikContext } from 'formik'

import { insertValueInString } from '../../../utils/common'
import { FieldStackedLabel } from '../../Field'
import { FormFieldSelectNG } from '../../Form'
import { FormikField } from '../../Formik'
import { DOC_FLOW_FORM_FIELD_VARIABLE } from '../DocFlow.constants'

import { API_PARAMS } from './DocFlowVariableField.constants'
import {
  getDocFlowVariableFieldValueProps,
  isLimitExceed,
} from './DocFlowVariableField.utils'
import { DocFlowVariableSelect } from './DocFlowVaribleSelect'

function DocFlowVariableField({
  controlProps,
  inputLabel,
  inputRef,
  titleFieldName,
  ...restProps
}) {
  const { t } = useTranslation()

  const { setFieldError, setFieldValue, values } = useFormikContext()

  const documentTitle = values[titleFieldName]
  const variableValue = values[DOC_FLOW_FORM_FIELD_VARIABLE]

  useEffect(() => {
    if (variableValue) {
      if (isLimitExceed(documentTitle, variableValue)) {
        setFieldError(
          titleFieldName,
          t('DocumentStapling.ExceededLimitFinalDocumentFieldErrorKey')
        )
      } else {
        const cursorPosition =
          inputRef.current?.selectionStart ?? documentTitle?.length ?? 0

        setFieldError(titleFieldName, null)

        setFieldValue(
          titleFieldName,
          insertValueInString({
            insertedValue: variableValue.label,
            position: cursorPosition,
            str: documentTitle,
          })
        )
      }
    }
  }, [variableValue])

  return (
    <FormikField
      {...restProps}
      {...(inputLabel
        ? {
            Field: FieldStackedLabel,
            fieldComponentProps: { label: inputLabel },
          }
        : null)}
      Component={FormFieldSelectNG}
      Select={DocFlowVariableSelect}
      apiParams={API_PARAMS}
      controlProps={{
        ...controlProps,
        contentProps: {
          inputProps: {
            placeholder: t(
              'DocumentStapling.ModalEditFinalDocumentVariablePlaceholderKey'
            ),
          },
        },
      }}
      getValueProps={getDocFlowVariableFieldValueProps}
      name={DOC_FLOW_FORM_FIELD_VARIABLE}
    />
  )
}

export default DocFlowVariableField
